import NativeOrWeb from './native';

/** PortfoPlus customer service — the number every "WhatsApp us" button uses (Pricing, SupportBottomSheet, …). */
export const SUPPORT_WHATSAPP = '85266370320';

interface IntlLike {
  formatMessage: (descriptor: { id: string }) => string;
}

/**
 * A WhatsApp to us asking to upgrade, written out so the adviser only presses
 * send. Prefixed (APP) / (WEB) like the support sheet's messages, so customer
 * service can tell where it came from.
 */
export const planUpgradeWhatsAppUrl = (intl: IntlLike): string => {
  const channel = NativeOrWeb.isNativePlatform() ? '(APP)' : '(WEB)';
  const text = `${channel} ${intl.formatMessage({ id: 'plan-upgrade-whatsapp-msg' })}`;
  return `https://api.whatsapp.com/send?phone=${SUPPORT_WHATSAPP}&text=${encodeURIComponent(text)}`;
};

/**
 * The Pro-required prompt for an adviser with no current core plan. The upgrade
 * sheet and /subscription both work from the current plan, so with none they
 * show nothing to buy (and iOS cannot buy there at all); the button asks us
 * on WhatsApp instead.
 */
export const planlessProDialog = (intl: IntlLike) => ({
  upgradeLabelId: 'pro-dialog-contact-us',
  onUpgrade: () => {
    window.open(planUpgradeWhatsAppUrl(intl), '_blank');
  }
});
